import { render, staticRenderFns } from "./cedis.vue?vue&type=template&id=0704bb36&scoped=true"
import script from "./cedis.vue?vue&type=script&lang=js"
export * from "./cedis.vue?vue&type=script&lang=js"
import style0 from "./cedis.vue?vue&type=style&index=0&id=0704bb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704bb36",
  null
  
)

export default component.exports